<template>
  <div>
    <section class="otherView">
      <RouterView />
    </section>
    <!-- 底部tabbar -->
    <van-tabbar v-model="active" route v-if="outside">
      <van-tabbar-item
        v-for="item in tabbarList"
        :to="item.path"
        :icon="item.icon"
        :key="item.path"
      >
        {{ item.name }}
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>


<script setup>
import { reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
const active = ref("riderHome");
const router = useRouter();
const tabbarList = reactive([
  { name: "订单", icon: "home-o", path: "/riderHome" },
  { name: "我的", icon: "user-o", path: "/riderMy" },
]);
const outside = ref(false);

watch(
  () => router.currentRoute.value.path,
  (toPath) => {
    let from = router.currentRoute.value;
    outside.value = from.name == "riderHome" || from.name == "riderMy";
    // console.log(1, outside.value);
  },
  { immediate: true, deep: true }
);
</script>